span.separator {
  margin: 0 10px;
}
